const moment = require("moment");

// The canonical on-platform due-date shape. Mirrors constants.dayFormat in
// ./utilities, which cannot be required here because it pulls in the Firebase
// store config.
const DAY_FORMAT = "YYYYMMDD";

// Normalizes whatever the approval UI hands over — a react-datepicker Date, an
// ISO timestamp, or an already-canonical string — into YYYYMMDD. Returns '' for
// anything unparseable so callers keep their existing "no due date" branch.
const canonicalDueDate = (value) => {
  if (!value && value !== 0) return "";
  const parsed = value instanceof Date ? moment(value) : moment(String(value), [DAY_FORMAT, moment.ISO_8601], true);
  return parsed.isValid() ? parsed.format(DAY_FORMAT) : "";
};

module.exports = {
  DAY_FORMAT,
  canonicalDueDate,
};
